// Active state configuration, selected via REACT_APP_STATE_CODE (default "TX").
// Import the single default export anywhere identity/contact/SEO/routing values
// are needed so components stay state-agnostic.
import { REGISTRY } from "./states";

const CODE = (process.env.REACT_APP_STATE_CODE || "TX").toUpperCase();

const config = REGISTRY[CODE];

if (!config) {
  throw new Error(
    `REACT_APP_STATE_CODE="${CODE}" is not registered. Available: ${Object.keys(
      REGISTRY
    ).join(", ")}`
  );
}

export const stateConfig = config;
export default config;
